import { Command, EditorState } from "prosemirror-state";
import { useCallback, useMemo } from "react";
import { insertImage } from "../commands/insertImage";
import { hasNodes } from "../schema";
import { Schema } from "prosemirror-model";
import { CallbackWithSchemaResult, useExtendWithSchema } from "./useExtendWithSchema";

export type ImageToolHandlers = {
	isSupportedBySchema: true;
	insertImage(
		uri: string
	): void;
} | {
	isSupportedBySchema: false;
};

export function useImageTools(
	editorState: EditorState,
	applyCommand: (command: Command) => void,
	focus?: () => void
): ImageToolHandlers {
	const insertImageHandler: CallbackWithSchemaResult<
		[uri: string],
		void
	> = useExtendWithSchema(
		editorState.schema,
		schema => hasNodes(schema, ["image"]),
		useCallback(
			(schema: Schema<"image", never>, uri: string): void => {
				applyCommand(
					insertImage(schema, uri)
				);
				focus?.();
			},
			[applyCommand, focus]
		)
	);

	return useMemo(
		(): ImageToolHandlers => {
			if (!insertImageHandler.isSupportedBySchema) {
				return {
					isSupportedBySchema: false
				};
			}

			return {
				isSupportedBySchema: true,
				insertImage: insertImageHandler
			};
		},
		[insertImageHandler]
	);
};